import { useEffect } from "react";
import bodyScrollLock from "../utils/bodyScrollLock";

export function useBodyScrollLock(shouldLock) {
  useEffect(() => {
    if (shouldLock) {
      bodyScrollLock.enable();
    } else {
      bodyScrollLock.disable();
    }

    return () => {
      bodyScrollLock.disable();
    };
  }, [shouldLock]);
}
